<template>
  <div id="page1_bscdown">
    <div class="box">
      <div id="page1_bscdowndiv" style="height:96%;width:96%;"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';

export default {
  name: 'page1_bscdown',
  data() {
    return {
      // 需要合并对象，样式
      options: {},
      dataset: [
        [0.0341, 0.0341, 0.0491, 0.0297, 0.0297, 0.0297, 0.0297],
        [0.0277, 0.0277, 0.0412, 0.0401, 0.0401, 0.0401, 0.0401],
        [0.0334, 0.0334, 0.0483, 0.0259, 0.0259, 0.0259, 0.0259]
      ],
      NowYearTargetValue: [
        '延峰汇总',
        '内饰',
        '外饰',
        '座椅',
        '安全',
        '电子',
        'AYM'
      ]
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
  },
  methods: {
    refreshChart(chartData) {
      // 生成数据
      const data1 = []
      const data2 = []
      const data3 = []
      const titleData = []
      if (chartData !== undefined) {
        for (let i = 0; i < chartData.length; i++) {
          titleData.push(chartData[i].DisplayName)
          data1.push(chartData[i].LastYearPracticalValue)
          data2.push(chartData[i].PracticalValue)
          data3.push(chartData[i].PlanValue)
          this.NowYear = chartData[i].Year
        }
      }
      this.dataset = [data1, data2, data3]
      this.NowYearTargetValue = titleData

      var myChart = echarts.init(document.getElementById('page1_bscdowndiv'));
      myChart.clear()

      var zoomConfig = []
      if (data1.length > 8) {
        zoomConfig.push({ type: 'inside', start: 0, end: 8 / data1.length * 100 })
      }
      var option = {
        title: {
          text: this.locale('tce/¥10K (YOY)','万元产值能耗(YOY)'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          x: 'right',
          y: 50,
          orient: 'vertical',
          textStyle: {
            color: '#ffffff',
            fontSize: 16
          },
          data: [
            '' + (this.NowYear - 1),
            '' + this.NowYear,
            this.locale('Target','目标')
          ]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.NowYearTargetValue,
            axisLabel: {
              interval: 0,
              color: '#ffffff',
              fontSize: 16
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.locale('tce/¥10K','吨标煤/万元'),
            nameTextStyle: {
              color: '#ffffff',
              fontSize: 16
            },
            boundaryGap: [0, '10%'],
            axisLabel: {
              color: '#ffffff',
              fontSize: 16
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        dataZoom: zoomConfig,
        series: [
          {
            name: this.NowYear - 1,
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#C1E7FD'
              }
            },
            barWidth: '30%',
            data: this.dataset[0],
            label: {
              color: '#eee'
            }
          },
          {
            name: this.NowYear,
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#70DF00'
              }
            },
            barWidth: '30%',
            data: this.dataset[1]
          },
          {
            name: this.locale('Target','目标'),
            type: 'line',
            itemStyle: { normal: { color: '#1E90FF' } },
            barWidth: '30%',
            data: this.dataset[2],
            symbol: 'diamond'
          }
        ]
      };

      // 5：展示数据
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="less" >
#page1_bscdown {
  position: relative;
  width: 33%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  margin-left:10px;
  margin-right: 20px;
  .box {
    height: 100%;
    width: 100%;
  }
}
</style>
